import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'app-confirm-delete-modal-component',
    templateUrl: './confirm-delete-modal.component.html'
})
export class ConfirmDeleteModalComponent {
    @ViewChild('confirmDeleteModal', {static: false}) confirmDeleteModal: ModalDirective;
    private finishPromise = new Promise<void>(() => {
    });
    private resolveFinishPromise = () => {
    };

    constructor() {
    }

    public deletedIdentifier: string;
    public isShowDefaultText = true;
    public confirmationText = '';
    public submitLebel = '';

    public show(deletedIdentifier: string) {
        this.isShowDefaultText = true;
        this.deletedIdentifier = deletedIdentifier;
        setTimeout(() => {
            this.confirmDeleteModal.show();
        }, 200);
    }

    public async showAwait(deletedIdentifier: string = "") {
        this.isShowDefaultText = true;
        this.finishPromise = new Promise<void>(resolve => this.resolveFinishPromise = resolve);
        this.deletedIdentifier = deletedIdentifier;
        this.confirmDeleteModal.show();
        await this.finishPromise;
        return this.deleted;
    }

    public async showCustomTextAwait(confirmationText: string, submitLebel: string) {
        this.isShowDefaultText = false;
        this.submitLebel = submitLebel;
        this.confirmationText = confirmationText;
        this.finishPromise = new Promise<void>(resolve => this.resolveFinishPromise = resolve);
        this.confirmDeleteModal.show();
        await this.finishPromise;
        return this.deleted;
    }

    deleted: boolean;

    public delete() {
        this.deleted = true;
        this.confirmDeleteModal.hide();
        this.resolveFinishPromise();
    }

    public discard(){
        this.deleted = false;
        this.confirmDeleteModal.hide();
        this.resolveFinishPromise();
    }

}
